import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HowWeInvestComponent } from 'src/app/pages/how-we-invest/how-we-invest.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: HowWeInvestComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HowWeInvestRoutingModule { }
